(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wajs", [], factory);
	else if(typeof exports === 'object')
		exports["wajs"] = factory();
	else
		root["wajs"] = factory();
})(window, function() {
return 